import { render, staticRenderFns } from "./RsCanvas.vue?vue&type=template&id=b4d7fa9e&scoped=true&"
import script from "./RsCanvas.vue?vue&type=script&lang=js&"
export * from "./RsCanvas.vue?vue&type=script&lang=js&"
import style0 from "./RsCanvas.vue?vue&type=style&index=0&id=b4d7fa9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d7fa9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
